import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { IMenuItem } from "src/framework/store";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(3),
    },

    expandable: {
      color: "rgba(0, 163, 53, 0.8)",
    },
  })
);

const MenuItem = ({
  menuItem,
  nested = false,
}: {
  menuItem: IMenuItem;
  nested: boolean;
}) => {
  const classes = useStyles();

  const location = useLocation();
  const [open, setOpen] = React.useState(false);

  let isExpandable =
    menuItem.link === null &&
    !!menuItem.menuItem &&
    menuItem?.menuItem?.length > 0;
  const handleClick = () => {
    if (!isExpandable) {
      return null;
    }

    setOpen(!open);
  };

  const controllClasses = isExpandable
    ? `${classes.expandable}`
    : "" + nested
      ? ` ${classes.nested}`
      : "";

  return (
    <div>
      <ListItem
        color="primary"
        button
        component={NavLink}
        exact
        to={menuItem.link || location.pathname}
        selected={location.pathname === menuItem.link}
        onClick={handleClick}
        className={controllClasses}
      >
        {!isExpandable ? (
          <ListItemIcon>
            <Icon>{menuItem.icon}</Icon>
          </ListItemIcon>
        ) : (
          ""
        )}

        <ListItemText primary={menuItem.text} />
        {isExpandable ? open ? <ExpandLess /> : <ExpandMore /> : ""}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {menuItem?.menuItem?.map((subMenu, index) => (
          <MenuItem
            menuItem={subMenu}
            nested={true}
            key={`subMenu-${btoa("subMenu-" + index)}`}
          />
        ))}
      </Collapse>
    </div>
  );
};

export { MenuItem };
